import {Pipe} from "@angular/core";

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe {
  transform(value: string | number, args: string[]) : string {
    if (value) {
      value = value.toString();
      const limit = args.length > 0 ? parseInt(args[0], 10) : 10;
      const trail = args.length > 1 ? args[1] : '...';

      return value.length > limit ? value.substring(0, limit) + trail : value;
    }else {
      return "";
    }

  }
}
